module.exports = __webpack_public_path__ + "static/media/pm.1bed419b.svg";